import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, FileText } from 'lucide-react';

export default function TermsOfService() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-zinc-950 text-white" data-testid="terms-page">
      <nav className="border-b border-zinc-800 bg-zinc-900/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-3">
              <img src="/logo.png" alt="FutureXV" className="h-10" />
              <span className="text-zinc-600">|</span>
              <span className="font-heading font-bold">Terms of Service</span>
            </div>
            <Button onClick={() => navigate(-1)} variant="ghost" className="text-zinc-400 hover:text-white"><ArrowLeft className="w-4 h-4 mr-2" />Back</Button>
          </div>
        </div>
      </nav>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="flex items-center gap-3 mb-8">
          <FileText className="w-8 h-8 text-primary-neon" />
          <h1 className="text-4xl font-heading font-bold" data-testid="terms-heading">Terms of Service</h1>
        </div>
        <div className="prose prose-invert max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-heading font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="text-zinc-300 leading-relaxed">By creating an account on FutureXV, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our platform. For users under 18, a parent or legal guardian must accept these terms on your behalf.</p>
          </section>
          <section>
            <h2 className="text-2xl font-heading font-bold text-white mb-4">2. Platform Overview</h2>
            <p className="text-zinc-300 leading-relaxed">FutureXV is a national digital rugby discovery platform designed to connect rugby players, coaches, schools, clubs, and scouts. The platform provides verified digital profiles, talent discovery tools, and development resources.</p>
          </section>
          <section>
            <h2 className="text-2xl font-heading font-bold text-white mb-4">3. User Accounts</h2>
            <ul className="list-disc list-inside text-zinc-300 space-y-2">
              <li>You must provide accurate and complete registration information</li>
              <li>You are responsible for maintaining the confidentiality of your account credentials</li>
              <li>All accounts are subject to administrator approval before full access is granted</li>
              <li>You must not create accounts for anyone other than yourself (unless registering as a parent/guardian for a minor)</li>
              <li>FutureXV reserves the right to suspend or terminate accounts that violate these terms</li>
            </ul>
          </section>
          <section>
            <h2 className="text-2xl font-heading font-bold text-white mb-4">4. User Responsibilities</h2>
            <ul className="list-disc list-inside text-zinc-300 space-y-2">
              <li>Provide truthful information in your profile</li>
              <li>Do not misrepresent your identity, age, qualifications, or affiliations</li>
              <li>Respect other users and maintain professional conduct</li>
              <li>Do not use the platform for commercial solicitation outside its intended purpose</li>
              <li>Do not attempt to access accounts or data belonging to other users</li>
            </ul>
          </section>
          <section>
            <h2 className="text-2xl font-heading font-bold text-white mb-4">5. Content and Media</h2>
            <p className="text-zinc-300 leading-relaxed">Users retain ownership of content they upload. By uploading content, you grant FutureXV a non-exclusive license to display that content within the platform for the purposes of talent discovery. FutureXV will not sell or redistribute your content to third parties without explicit consent.</p>
          </section>
          <section>
            <h2 className="text-2xl font-heading font-bold text-white mb-4">6. Verification Process</h2>
            <p className="text-zinc-300 leading-relaxed">Player profiles may be verified through coach endorsement and administrator review. Verified profiles are distinguished with a verification badge. FutureXV does not guarantee the accuracy of unverified profiles and encourages all scouts and institutions to rely on verified data.</p>
          </section>
          <section>
            <h2 className="text-2xl font-heading font-bold text-white mb-4">7. Free Access</h2>
            <p className="text-zinc-300 leading-relaxed">Access to FutureXV is free for players, schools, and clubs. The platform may introduce premium features for scouts and professional organisations in the future. Any pricing changes will be communicated in advance.</p>
          </section>
          <section>
            <h2 className="text-2xl font-heading font-bold text-white mb-4">8. Limitation of Liability</h2>
            <p className="text-zinc-300 leading-relaxed">FutureXV acts as a discovery platform and does not guarantee outcomes including selection, scholarships, or recruitment. We are not liable for decisions made by scouts, coaches, or institutions based on information on our platform.</p>
          </section>
          <section>
            <h2 className="text-2xl font-heading font-bold text-white mb-4">9. Governing Law</h2>
            <p className="text-zinc-300 leading-relaxed">These terms are governed by the laws of the Republic of South Africa. Any disputes will be resolved under South African jurisdiction.</p>
          </section>
          <section>
            <h2 className="text-2xl font-heading font-bold text-white mb-4">10. Contact</h2>
            <p className="text-zinc-300">For queries regarding these terms, contact us at info@futurexv.co.za</p>
          </section>
          <p className="text-zinc-500 text-sm mt-8">Last updated: February 2026</p>
        </div>
      </div>
    </div>
  );
}
